import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a050397&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./uploader.css?vue&type=style&index=0&id=6a050397&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a050397",
  null
  
)

component.options.__file = "index.vue"
export default component.exports